import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TaskCard({ task }) {
    return (_jsxs("div", { className: "bg-white p-2 rounded shadow text-sm", children: [_jsx("div", { className: "font-medium", children: task.title }), task.due_date && _jsxs("div", { className: "text-xs text-slate-500 mt-1", children: ["\u0633\u0631\u0631\u0633\u06CC\u062F: ", task.due_date] })] }));
}
